export const multiselect = {
  multiselect: {
    chip: {
      border: {
        radius: 'var(--p-border-radius-xl)',
      },
    },
  },
};
